import { createFileRoute } from "@tanstack/react-router";

import { ResetRequestForm } from "@/components/ResetRequestForm";

export const Route = createFileRoute("/reset-request")({
  component: ResetRequestForm,
});
